import {Injectable} from "@angular/core";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {ProviderSummary, ServerConstantsService, WpProvider} from "../shared";
import {Observable} from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';


@Injectable()
export class ProviderService {

  private resourceUrl: string;
  ServerConstants: any;

  constructor (
    private http: HttpClient,
    private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.resourceUrl = this.ServerConstants.SERVER_API_URL + '/providers';
  }

  findAllProviders(pageNumber: number, pageSize: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/getAllProviders?page=${pageNumber}&size=${pageSize}`,{ observe: 'response' });
  }

  findAllProvidersList(): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.resourceUrl}/getAllProvidersList`,{ observe: 'response' });
  }

  findAllActiveProviders(): Observable<any> {
    return this.http.post<any>(`${this.resourceUrl}/getAllActiveProviders`,{ observe: 'response' });
  }

  save(providerSummary:ProviderSummary): Observable<HttpResponse<ProviderSummary>>{
    return this.http.post<ProviderSummary>(`${this.resourceUrl}/save`, providerSummary, { observe: 'response' });
  }

  getProvider( provider: WpProvider): Observable<HttpResponse<WpProvider>> {
    return this.http.post<any>(`${this.resourceUrl}/search`, provider, { observe: 'response' });
  }
  getAllProvidersList(token): Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + token
      })
    }; 
    console.log(this.resourceUrl);
    return this.http.post(this.resourceUrl +'/getAllProvidersList', {}, httpOptions)
  }
  saveProviderDetails(token,data): Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + token
      })
    }; 
    console.log(this.resourceUrl);
    return this.http.post(this.resourceUrl +'/save',data, httpOptions)
  }
  getcountyDetails(id): Observable<any>{
    console.log(this.resourceUrl);
    return this.http.post(this.resourceUrl +'/get-provider-counties',id)
  }
  saveCountyDetails(token,data): Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + token
      })
    }; 
    console.log(this.resourceUrl);
    return this.http.post(this.resourceUrl +'/provider-county/save',data, httpOptions)
  }
  getofficeDetails(providerId, countyId): Observable<any>{
    console.log(this.resourceUrl);
    return this.http.post(this.resourceUrl +'/get-all-office',{"providerId":providerId,"county":countyId})
  }
  saveOfficeDetails(token,data): Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + token
      })
    }; 
    console.log(this.resourceUrl);
    return this.http.post(this.resourceUrl +'/office/save',data, httpOptions)
  }

}



// WEBPACK FOOTER //
// ./src/app/provider-management/provider-management.service.ts